import useWindowSize from "@GeriMed/Common/Hooks/useWindowSize";
import { getPageLinkByPageType } from "@GeriMed/Overrides/Store/Links/LinksSelectors";
import themeColors, { themeFonts, themeFontsSize, themeFontWeights } from "@GeriMed/styles/variables";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchInput from "@insite/content-library/Widgets/Header/SearchInput";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import List from "@insite/mobius/Icons/List";
import Search from "@insite/mobius/Icons/Search";
import User from "@insite/mobius/Icons/User";
import Link from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    view: state.pages.productList.view,
    session: state.context.session,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        css: css`
            &.listing-column-container {
                > div {
                    margin: 0;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        `,
                    ],
                    "min",
                )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`{
                            &.listing-column-container {
                                max-width: 100% !important;
                            }
                        }`,
                        css`
                            &.listing-column-container {
                                > div {
                                    width: 100%;
                                    justify-content: flex-end;
                                }
                                a,
                                button {
                                    &:focus {
                                        outline: none;
                                        background-color: ${themeColors.lightGray67};
                                    }
                                }
                                .login-wrap span {
                                    font-weight: ${themeFontWeights.semiBold};
                                    color: ${themeColors.lightBlack};
                                    font-size: ${themeFontsSize.size14};
                                    &:hover{
                                        color: ${themeColors.lightBlack};
                                    }
                                }
                            }

                            .search-modal{
                                max-height: 40px;
                                button {
                                    background: none;
                                    color: ${themeColors.colorBlack};
                                    padding: 10px 18px;
                                    line-height: ${themeFontsSize.size18};
    
                                    svg {
                                        width: 20px;
                                    }
                                }
                            } 

                            .login-wrap {
                                a {
                                    line-height: 40px;
                                    font-size: ${themeFontsSize.size14};
                                    padding: 0 18px;
                                    border-left: 1px dotted ${themeColors.lightGray6};
                                    border-right: 1px dotted ${themeColors.lightGray6};
                                }

                                &.active{
                                    background-color: ${themeColors.lightGray67};
                                }
                            }
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = columnsStyles;

const SignInAndSearch: FC<Props> = ({ id, view, signInUrl, session }) => {
    const { width } = useWindowSize();
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const [toggleContent, setToggleContent] = React.useState(false);
    const openHeaderSearch = () => {
        const conditionCheck = document.querySelector(".headerSearchWrapper");
        if (conditionCheck) {
            conditionCheck.classList.toggle("active", !conditionCheck.classList.contains("active"));
        }
    };

    const customerInfoToggle = () => {
        setToggleContent(!toggleContent);
        const conditionCheck = document.querySelector(".customer-info-wrap");
        if (conditionCheck) {
            conditionCheck.classList.toggle("active", !conditionCheck.classList.contains("active"));
        }
    };
    return (
        <GridContainer {...styles.container} className="listing-column-container">
            {width < 768 && (
                <>
                   {!isAuthenticated && (
                    <div className="login-wrap">
                        <Link href={signInUrl}>
                            Sign In
                        </Link>
                    </div>
                    )}
                    {isAuthenticated && (
                    <div className={`login-wrap ${toggleContent?'active':''}`} onClick={customerInfoToggle} >
                        <span className="sign-out"> 
                           <User />
                        </span>
                    </div>
                    )}
                    <div className="search-modal">
                        <Button onClick={openHeaderSearch}>
                            <Search />
                        </Button>
                    </div>
                </>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SignInAndSearch),
    definition: {
        group: "Header",
        displayName: "Mobile Search Input",
    },
};

export default widgetModule;
